import pic1 from './../Assets/Gallery/download.jpg'
import pic2 from './../Assets/Gallery/download1.jpg'
import pic3 from './../Assets/Gallery/download2.jpg'

const gallery_contnet = [
    {
        id: 1,
        photo_name: "ROBOCON PARTICIPATIONS",
        imgURL: pic1,
    },
    {
        id: 2,
        photo_name: "WORKSHOPS AND SEMINARS",
        imgURL: pic2,},
    {
        id: 3,
        photo_name: "ROBO SUPER LEAGUE",
        imgURL: pic3,
    },


]
export default gallery_contnet